/**
 * @Auther: Qsan
 * @Date：2018年12月12日 00:22
 * @Desc：订单管理相关接口
 */
import env from '@common/env'
import { get, post, put, deletes } from '@common/http'

/**
 * 根据分页查找TOrderBase
 * @param param
 * @returns {*}
 */
export const getOrder = (param) => get('/order', param)

//
export const getOrderIdDetails = (param) => get(`/order/page-with-detail`, param)

// 查看修改业绩权限
export const getModifyAuth = (param) => get('/order-brokerage/get-modify-auth', param)
/**
 * web开单
 * @param param
 * @returns {*}
 */
export const postOrder = (param) => post('/order', param)
export const cardOrder = (param) => post('/order/addForIndividuality', param)

/**
 * 修改TOrderBase信息
 * @param param
 * @returns {*}
 */
export const putOrder = (param) => put('/order', param)

/**
 * 修改客数
 * @param {*} param
 */
export const putOrderUpdateCustomerCount = (param) => put('/order/updateCustomerCount', param)

/**
 * 撤单
 * @param {*} param
 */
export const putOrderStatus = (param) => post('/order/revoke-order', param)

/**
 * 对单
 */
export const updateSingle = (identification, id) => put(`/order/updateSingle?identification=${identification}&id=${id}`)

/**
 * 批量对单
 */
export const BatchOrderSingle = (param) => put(`order/batchToSingle`, param)

/**
 * 根据分页查找TOrderBase
 * @param param
 * @returns {*}
 */
export const getOrderId = (id) => get(`/order/${id}`)
/**
 * 删除TOrderBase信息
 * @param param
 * @returns {*}
 */
export const deleteOrderId = (id) => deletes(`/order/${id}`)

/**
 * 获取订单信息详情,包含详细信息和提成信息
 * @param param
 * @returns {*}
 */
export const getOrderIdDetail = (id) => get(`/order/${id}/detail`)

/**
 * 批量修改TOrderBase信息
 * @param param
 * @returns {*}
 */
export const putOrderBatch = (param) => put('/order/batch', param)

/**
 * 批量删除TOrderBase信息
 * @param param
 * @returns {*}
 */
export const deleteOrderBatch = (param) => deletes(`/order/batch`, param)

/**
 * 消费的时候单项的展示和提成
 * @param param
 * @returns {*}
 */
export const getOrderConsume = (param) => post(`/order/consume-brokerage`, param)

/**
 * 获取开卡详情的展示，这里会展示卡内容和员工该得的业绩
 * @param param
 * @returns {*}
 */
export const getCreateCardDetail = (param) => get(`/order/create-card-detail-and-brokerage`, param)

/**
 * 获取开卡详情的展示，这里会展示卡内容和员工该得的业绩
 * @param param
 * @returns {*}
 */
export const getPersonalityCreateCardDetail = (param) => get(`/order/create-individuality-card-detail-and-brokerage`, param)
// http://localhost:4000/order//create-individuality-card-detail-and-brokerage?tenantCardId=707b63b583d03cec8cb3a7d843b87014&originPrice=100&employeeIds=d2f2a401c3c856fd6e68889d3a000819,9dead2c4c3281ac85bfe81961ec99024
/**
 * 查找TOrderBase
 * @param param
 * @returns {*}
 */
export const postOrderInfo = (param) => post('/order/info', param)

/**
 * 根据list查找TOrderBase
 * @param param
 * @returns {*}
 */
export const getOrderlist = (param) => get(`/order/list`, param)

/**
 * 修改提成
 * @param param
 * @returns {*}
 */
export const postModifyBrokerage = (param) => post('/order/modify-brokerage', param)

/**
 * 根据分页查找TOrderBase,并携带会员信息
 * @param param
 * @returns {*}
 */
export const getPageWithMember = (param) => get('/order/page-with-member-info', param)

/**
 * 充值时候展示提成
 * @param param
 * @returns {*}
 */
export const getOrderRecharge = (param) => get('/order/recharge-brokerage', param)

// 开单中根据手机号获取用户信息 信息
export const postMemberBaseInfo = (param) => post('/member-base/info', param)

// 开单 获取手机号模糊查询
export const getMemberBasePhone = (param) => get('/member-base/list', param)
// 开单 查询会员信息
export const getMemberBaseList = (param) => get('/member-base/queryList', param)

/**
 * 获取缺失单号
 * @param param
 * @returns {*}
 */
export const getDefectCode = (param) => get('/order/find-missing-serial-mun', param)

/**
 * 开单  待付款订单下单
 * @param param
 * @returns {*}
 */
export const postWebOrderPlease = (param) => post('/order/webOrderPlease', param)

/**
 * 开单  待付款批量结账
 * @param param
 * @returns {*}
 */
export const postWebOrderPleaseForBatch = (param) => post('/order/webOrderPleaseForBatch', param)

/**
 * 开单  待付款批量取消
 * @param param
 * @returns {*}
 */
export const putBatch = (param) => put('/order/batch', param)

// 优惠金额&&折扣金额统计
export const getDiscountAmountData = (param) => get('/statistic/countDiscountAmount', param)

// 其他扣款记录
export const getOtherDebitRecords = (param) => get('/member-other-consume', param)

// 小程序个性次卡下单pc端结账
export const webOrderPleaseOfIndividualityCard = (param) => post('/order/webOrderPleaseOfIndividualityCard', param)

/**
 * 开单  待付款批量结账
 * @param param
 * @returns {*}
 */
export const putPersonalityCard = (param) => put('/order-payment/edit', param)

// 部门业绩统计列表
export const getDepartmentPerformance = (param) => get('/departmentAchievement/list', param)

// 修改部门统计业绩
export const putDepartmentPerformance = (param) => put('/departmentAchievement', param)

// 获取订单id
export const getOrdermemberCardIdGetOrderId = (param) => get('/order/memberCardIdGetOrderId', param)

// 获取次卡总金额
export const getSelTotalCard = (param) => get('/statistic/selTotalCard', param)

// 获取次卡是否可以耗卡
export const getPackageNew = (param) => get(`/order/getPackageNew?oldPackageId=${param.oldPackageId}&newPackageId=${param.newPackageId}&memberCardId=${param.memberCardId}&oldNum=${param.oldNum}&num=${param.num}&isDiscount=${param.isDiscount}`)



// WEBPACK FOOTER //
// ./src/api/order.js